<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      eager
      persistent
      scrollable
      max-width="900px"
    >
      <v-card>
        <v-card-title dark class="dialog-header">
          <div class="dialog-header-content">
            <div class="dialog-title-wrapper">
              <div class="dialog-icon">
                <icon name="global-icon" />
              </div>

              <div class="dialog-text">
                <div class="dialog-title">Strategic Plan Summary</div>

                <div class="dialog-subtitle">
                  View and monitor the overall progress of strategic plans and
                  organizational objectives.
                </div>
              </div>
            </div>

            <v-btn icon class="close-btn" @click="closeD()">
              <icon name="circle-close" />
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text style="max-height: 700px" class="my-4">
          <v-row>
            <v-col cols="8" class="flex-items mt-2">
              <div class="ml-3">
                <div class="goal-description">Goals</div>
              </div>
            </v-col>

            <v-spacer></v-spacer>
            <v-col cols="2" class="d-flex justify-end mt-2 mr-2"> </v-col>
            <v-col cols="12" class="pt-2 px-4">
              <v-card class="dt-container" elevation="0" outlined>
                <v-data-table
                  :expanded1.sync="expanded1"
                  :headers="headers"
                  show-expand
                  single-expand
                  :items="dataItem"
                  :items-per-page="10"
                  @item-expanded="loadStrategicOutcomes"
                >
                  <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length" class="pa-4">
                      <div class="py-1 goal-description">
                        Strategic Outcomes
                      </div>
                      <div>
                        <v-data-table
                          :expanded2.sync="expanded2"
                          :headers="strategy_outcome_headers"
                          :items="item.strategy_outcome_data"
                          show-expand
                          single-expand
                          hide-default-footer
                          @item-expanded="loadSOStategies"
                        >
                          <template v-slot:expanded-item="{ headers, item }">
                            <td :colspan="headers.length" class="pa-4">
                              <div class="py-1 goal-description">Strategy</div>
                              <div>
                                <v-data-table
                                  :expanded3.sync="expanded3"
                                  :headers="strategy_headers"
                                  :items="item.strategy_data"
                                  single-expand
                                  show-expand
                                  hide-default-footer
                                  @item-expanded="loadPAP"
                                >
                                  <template
                                    v-slot:[`item.description`]="{ item }"
                                  >
                                    {{ item.letterIndex + ". " }}
                                    {{ item.description }}
                                  </template>
                                  <template
                                    v-slot:expanded-item="{ headers, item }"
                                  >
                                    <td :colspan="headers.length" class="pa-4">
                                      <div class="py-1 goal-description">
                                        Programs, Activities and Projects
                                      </div>
                                      <div>
                                        <v-data-table
                                          :expanded4.sync="expanded4"
                                          :headers="pap_headers"
                                          single-expand
                                          :items="item.pap_data"
                                          @item-expanded="loadTagged"
                                          show-expand
                                          hide-default-footer
                                        >
                                          <template
                                            v-slot:[`item.kpi`]="{ item }"
                                          >
                                            <b>{{ item.code + ": " }}</b>
                                            {{ item.indicators }}
                                          </template>
                                          <template
                                            v-slot:expanded-item="{
                                              headers,
                                              item,
                                            }"
                                          >
                                            <td
                                              :colspan="headers.length"
                                              class="pa-4"
                                            >
                                              <div
                                                class="py-1 goal-description"
                                              >
                                                Annual Target Distribution
                                              </div>

                                              <div
                                                v-if="
                                                  !$vuetify.breakpoint.smAndDown
                                                "
                                              >
                                                <table class="annual_dist_tbl">
                                                  <thead>
                                                    <tr>
                                                      <td
                                                        align="center"
                                                        class="pa-2 div_tbl"
                                                        v-for="yr in item
                                                          .annual_target_dist
                                                          .year"
                                                        :key="yr"
                                                      >
                                                        {{ yr }}
                                                      </td>
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    <tr>
                                                      <td
                                                        class="pa-1"
                                                        v-for="(i, ctr) in item
                                                          .annual_target_dist
                                                          .data"
                                                        :key="ctr"
                                                      >
                                                        <div class="pa-1">
                                                          <div
                                                            class="d-flex justify-space-between"
                                                          >
                                                            <div
                                                              class="font-weight-bold"
                                                            >
                                                              Target:
                                                            </div>
                                                            <div>
                                                              {{ i.target }}
                                                            </div>
                                                          </div>
                                                          <div
                                                            class="d-flex justify-space-between"
                                                          >
                                                            <div
                                                              class="font-weight-bold"
                                                            >
                                                              Accomplishment :
                                                            </div>
                                                            <div>
                                                              {{
                                                                i.accomplishment
                                                              }}
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </td>
                                                    </tr>
                                                  </tbody>
                                                </table>
                                              </div>
                                              <div v-else style="width: 100%">
                                                <div
                                                  class="d-flex justify-space-between"
                                                >
                                                  <div
                                                    class="d-flex justify-center bordered_div pa-1 font-weight-bold div_tbl"
                                                  >
                                                    Year
                                                  </div>
                                                  <div
                                                    class="d-flex justify-center bordered_div pa-1 font-weight-bold div_tbl"
                                                  >
                                                    Target
                                                  </div>
                                                  <div
                                                    class="d-flex justify-center bordered_div pa-1 font-weight-bold div_tbl"
                                                  >
                                                    Accomplishment
                                                  </div>
                                                </div>
                                                <div
                                                  class="d-flex justify-space-between"
                                                  v-for="(i, ctr) in item
                                                    .annual_target_dist.data"
                                                  :key="ctr"
                                                >
                                                  <div
                                                    class="d-flex justify-center bordered_div pa-1"
                                                  >
                                                    {{ i.year }}
                                                  </div>
                                                  <div
                                                    class="d-flex justify-center bordered_div pa-1"
                                                  >
                                                    {{ i.target }}
                                                  </div>
                                                  <div
                                                    class="d-flex justify-center bordered_div pa-1"
                                                  >
                                                    {{ i.accomplishment }}
                                                  </div>
                                                </div>
                                              </div>
                                            </td>
                                          </template>
                                        </v-data-table>
                                      </div>
                                    </td>
                                  </template>
                                </v-data-table>
                              </div>
                            </td>
                          </template>
                        </v-data-table>
                      </div>
                    </td>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end">
          <v-card-text class="pa-1 mr-3 mt-8 d-flex justify-end">
            <v-spacer></v-spacer>

            <v-btn class="btn-cancel" outlined @click="closeD()"> Close </v-btn>
          </v-card-text>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
import icon from "@/assets/icon.vue";
export default {
  components: {
    icon,
    // addStrategy: () => import("./AddStrategy.vue"),
    // ViewPAP: () => import("./ViewPAP.vue"),
  },
  props: {
    data: null,
  },
  data() {
    return {
      remarksData: [],
      expanded1: [],
      expanded2: [],
      expanded3: [],
      expanded4: [],
      expanded5: [],
      isExpanded: false,
      confirmBtnLoading: false,
      confirmSubmitDialog: false,
      confirmDialog: false,
      itemToDelete: null,
      assesed_by_status: null,
      options: {},
      action: null,
      viewTargetData: null,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
      mporData: [],
      dialog: false,
      activeTab: { id: 2, name: "Strategic Priority" },
      tab: 2,
      tabList: [{ id: 2, name: "Strategic Priority" }],
      targetData: null,
      ipcrSupData: null,
      isSubmitted: null,
      targetRating: null,
      isSubmitLoading: false,
      assessed_by: null,
      assessed_by_status: null,
      final_rating_by: null,
      final_rating_by_status: null,
      id: null,
      dataItem: [],
      isButtonLoading: false,
      headers: [
        {
          text: "Description",
          value: "description",
          align: "start",
          valign: "start",
          // width: "50%",
          sortable: false,
        },
        {
          text: "Number of Strategic Outcomes",
          value: "so_count",
          align: "center",
          valign: "start",
          sortable: false,
        },
        // {
        //   text: "Goal Assigned",
        //   value: "vp_goal_role_description",
        //   align: "start",
        //   valign: "start",
        //   sortable: false,
        // },
      ],
      strategy_outcome_headers: [
        {
          text: "Description",
          value: "description",
          align: "start",
          valign: "start",
          // width: "50%",
          sortable: false,
        },
        {
          text: "Number of Strategies",
          value: "strat_count",
          align: "center",
          valign: "start",
          sortable: false,
        },
      ],
      strategy_headers: [
        {
          text: "Description",
          value: "description",
          align: "start",
          valign: "start",
          // width: "50%",
          sortable: false,
        },
        {
          text: "Number of PAP",
          value: "pap_count",
          align: "center",
          valign: "start",
          sortable: false,
        },
      ],
      pap_headers: [
        {
          text: "Key Performance Indicators",
          value: "kpi",
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "Definition and Specifics",
          value: "def_specs",
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "Baseline",
          value: "baseline",
          align: "center",
          // width: 200,
          valign: "center",
          sortable: false,
        },

        {
          text: "SDP Target",
          value: "sdp_target",
          align: "center",
          // width: 200,
          valign: "center",
          sortable: false,
        },
      ],
      annual_target_headers: [
        {
          text: "Year",
          value: "year",
          align: "start",
          valign: "start",

          sortable: false,
        },
        {
          text: "Target Distribution",
          value: "target_distribution",
          align: "center",

          sortable: false,
        },
        {
          text: "Budget Requirement",
          value: "budget_requirement",
          align: "center",

          sortable: false,
        },
        {
          text: "Tagged",
          value: "tagged",
          align: "center",

          sortable: false,
        },
      ],
    };
  },

  watch: {
    data: {
      handler(data) {
        this.dialog = true;
        this.expanded1 = [];
        this.expanded2 = [];
        this.expanded3 = [];
        this.expanded4 = [];
        this.expanded5 = [];
        this.id = data.id;
        console.log("STRAT ", data.id);
        // this.tab = 1;
        this.initialize();
      },
      deep: true,
    },
    options: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
  },
  mounted() {
    this.eventHub.$on("closeaddStrategy", () => {
      this.initialize();
    });
    this.eventHub.$on("closeViewPAP", () => {
      this.initialize();
    });
  },

  beforeDestroy() {
    this.eventHub.$off("closeaddStrategy");
    this.eventHub.$off("closeViewPAP");
  },

  methods: {
    initialize() {
      this.expanded1 = [];
      this.expanded2 = [];
      this.expanded3 = [];
      this.expanded4 = [];
      this.expanded5 = [];
      this.loading = true;
      if (this.id) {
        this.axiosCall("/strategic-planning/getGoals/" + this.id, "GET").then(
          (res) => {
            if (res) {
              this.dataItem = res.data;
              console.log("GOLAD", res.data);
              this.loading = false;
            }
          },
        );
      }
    },

    getTaggedTargetTotal(tagged) {
      if (tagged.length > 0) {
        let t = 0;
        for (let i = 0; i < tagged.length; i++) {
          t += parseInt(tagged[i].target);
        }
        return t;
      } else {
        return null;
      }
    },

    loadStrategicOutcomes({ item }) {
      let index = this.dataItem.findIndex((e) => e.id == item.id);

      let goalID = item.id;
      this.axiosCall(
        "/strategic-planning/getStrategicOutcomeByGoal/" +
          this.id +
          "/" +
          goalID,
        "GET",
      ).then((res) => {
        Object.assign(this.dataItem[index], {
          strategy_outcome_data: res.data,
        });
      });
    },

    loadSOStategies({ item }) {
      console.log(item);
      let goalIndex = this.dataItem.findIndex((e) => e.id == item.goalID);
      let soIndex = this.dataItem[goalIndex].strategy_outcome_data.findIndex(
        (e) => e.id == item.id,
      );
      let goalID = item.goalID;
      let soID = item.id;

      this.axiosCall(
        "/strategic-planning/getStrategyByStrategicOutcomeAndGoal/" +
          this.id +
          "/" +
          goalID +
          "/" +
          soID,
        "GET",
      ).then((res) => {
        Object.assign(this.dataItem[goalIndex].strategy_outcome_data[soIndex], {
          strategy_data: res.data,
        });
      });
    },
    loadPAP({ item }) {
      let goalIndex = this.dataItem.findIndex((e) => e.id == item.goalID);

      let soIndex = this.dataItem[goalIndex].strategy_outcome_data.findIndex(
        (e) => e.id == item.strategic_outcomeID,
      );
      let stratIndex = this.dataItem[goalIndex].strategy_outcome_data[
        soIndex
      ].strategy_data.findIndex((e) => e.id == item.id);

      let goalID = item.goalID;
      let soID = item.strategic_outcomeID;
      let strategyID = item.id;
      this.axiosCall(
        "/strategic-planning/getPAPByStrategyStrategicOutcomeAndGoal/" +
          goalID +
          "/" +
          soID +
          "/" +
          strategyID,
        "GET",
      ).then((res) => {
        console.log(res.data);
        Object.assign(
          this.dataItem[goalIndex].strategy_outcome_data[soIndex].strategy_data[
            stratIndex
          ],
          {
            pap_data: res.data,
          },
        );
      });
    },

    loadTagged({ item }) {
      let goalIndex = this.dataItem.findIndex((e) => e.id == item.goalID);
      let soIndex = this.dataItem[goalIndex].strategy_outcome_data.findIndex(
        (e) => e.id == item.strategicOutcomeID,
      );
      let stratIndex = this.dataItem[goalIndex].strategy_outcome_data[
        soIndex
      ].strategy_data.findIndex((e) => e.id == item.strategyID);

      let papIndex = this.dataItem[goalIndex].strategy_outcome_data[
        soIndex
      ].strategy_data[stratIndex].pap_data.findIndex((e) => e.id == item.id);
      // console.log(
      //   "data item",
      //   this.dataItem[goalIndex].strategy_outcome_data[soIndex].strategy_data[
      //     stratIndex
      //   ]
      // );
      // let goalID = item.goalID;
      // let soID = item.strategicOutcomeID;
      // let strategyID = item.strategyID;
      // console.log("called", item);
      // // console.log("Tagged", item);
      this.axiosCall("/strategic-planning/getPAPTagged/" + item.id, "GET").then(
        (res) => {
          console.log("DATA", res.data);
          Object.assign(
            this.dataItem[goalIndex].strategy_outcome_data[soIndex]
              .strategy_data[stratIndex].pap_data[papIndex],
            {
              annual_target_dist: res.data,
            },
          );
        },
      );
    },

    getAnnualTargetHeader(item) {
      let arr = [];
      for (let i = 0; i < item.length; i++) {
        arr.push(item[i].year);
      }
      return arr;
    },

    closeD() {
      this.eventHub.$emit("closeViewStratPlanSummaryDialog", false);
      this.confirmSubmitDialog = false;
      this.confirmBtnLoading = false;
      this.isSubmitLoading = false;
      this.dialog = false;
    },
    View(item) {
      console.log(item);
      this.viewTargetData = item;
      this.action = "View";
    },

    edit(item) {
      console.log(item);
      this.targetData = item;
      this.action = "Update";
    },

    AddFunction() {
      this.targetData = { id: null, spID: this.id };
      this.action = "Add";
    },

    changeTab(tab) {
      this.activeTab = tab;
      this.tab = tab.id;
      this.initialize();
    },
    deleteItem(item) {
      this.itemToDelete = item;
      this.confirmDialog = true;
    },
    cancelDelete() {
      this.itemToDelete = null;
      this.confirmDialog = false;
    },

    confirmDelete() {
      this.isButtonLoading = true;
      console.log(this.itemToDelete.id);
      this.axiosCall(
        "/strategic-planning/deleteTarget/" + this.itemToDelete.id,
        "DELETE",
      ).then((res) => {
        if (res.data.status == 200) {
          this.confirmDialog = false;
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "success";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = res.data.msg;
          this.isButtonLoading = false;
          this.itemToDelete = null;
          this.confirmDialog = false;

          this.initialize();
        } else {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = res.data.msg;
          this.isButtonLoading = false;
        }
      });
    },
  },
};
</script>
<style scoped>
.tbl_x_scroll {
  border: 1px solid black;
  width: 100px;
  overflow-x: scroll;
}

.annual_dist_tbl {
  width: 100%;
  border-collapse: collapse;
}
.annual_dist_tbl td,
.annual_dist_tbl th {
  border: 1px solid grey;
}

.bordered_div {
  border: 1px solid grey;
  width: 100%;
}
.div_tbl {
  background-color: #147452 !important;
  color: white !important;
}
</style>
